import Logger from '../../../../common/logger';

const drawBinary = ratio => {
    const drawedNumber = Math.random();
    if (drawedNumber > ratio) {
        return 0;
    }
    return 1;
};

const drawMinimizedView = drawRatio => {
    if (drawRatio === undefined || drawRatio === 0) {
        Logger.log('drawMinimizedView: old contact icon view');
        return 0;
    }

    const optionIndex = drawBinary(drawRatio / 100);

    Logger.log(`drawMinimizedView: ${optionIndex ? 'new' : 'old'} contact icon view`);

    return optionIndex;
};

export default drawMinimizedView;
